import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosInstance, END_POINTS } from '../../integrations'

export const fetchLeaderBoard = createAsyncThunk(
    'get/getRank',
    async (data: { limit: number; page: number | number[]; time?: string }) => {
        try {
            let url = `${END_POINTS.rankingApi}?limit=${data.limit}&page=${data.page}`

            if (data.time === 'monthly') {
                url = `${END_POINTS.rankingApi}?limit=${data.limit}&page=${data.page}&mode=m`
            }

            const response = await AxiosInstance.get(url)
            return response
        } catch (error: any) {
            return error.message
        }
    }
)

export const fetchMyRankingLeaderBoard = createAsyncThunk(
    'get/getMyRanking',
    async (data: {
        limit: number
        page: number
        userRank?: number
        time?: string
    }) => {
        let result: any = []
        const { page } = data
        let pageToCallApi: number[] = []
        if (page === 1) {
            pageToCallApi = [1, 2]
        } else {
            pageToCallApi = [page - 1, page, page + 1]
        }

        let url = `${END_POINTS.rankingApi}?limit=${data.limit}`

        if (data.time === 'monthly') {
            url = `${END_POINTS.rankingApi}?limit=${data.limit}&mode=m`
        }
        try {
            for (let i = 0; i < pageToCallApi.length; i++) {
                const response = await AxiosInstance.get(
                    `${url}&page=${pageToCallApi[i]}`
                )

                result.push(response.data)
            }
            result = result.flat(1)
            const index = result.findIndex(
                (x: { rank: number }) => x.rank === data.userRank
            )
            const startIndex = index > 50 ? index - 50 : 0
            const endIndex = index < 50 ? index + (100 - index) : index + 51
            const arraySlice = (result = result.slice(startIndex, endIndex))
            return arraySlice
        } catch (error: any) {
            return error.message
        }
    }
)

export const fetchHallOfFame = createAsyncThunk('get/hallOfFame', async () => {
    try {
        const url = `${END_POINTS.userAPIS}top-ranks`

        const response = await AxiosInstance.get(url)
        return response
    } catch (error: any) {
        return error.message
    }
})

export const searchUserTag = createAsyncThunk(
    'get/searchUser',
    async (data: { userTag: string; selectedTime: string }) => {
        const userTagSearch = data.userTag.replace('@', '')
        const value = encodeURIComponent(userTagSearch)
        let url = `${END_POINTS.searchApi}?user_tag=${value}`
        if (data.selectedTime === 'monthly') {
            url = `${END_POINTS.searchApi}?user_tag=${value}&mode=m`
        }
        try {
            const response = await AxiosInstance.get(url)

            return response
        } catch (error: any) {
            return error.message
        }
    }
)

export const fetchMyProfile = createAsyncThunk(
    'get/getUser',
    async (mode?: string) => {
        const userKey = window.localStorage.getItem('FUTURE_USER_ID')

        let url = `${END_POINTS.userAPIS}${userKey}/rank`

        if (mode === 'monthly') {
            url = `${END_POINTS.userAPIS}${userKey}/rank?mode=m`
        }

        try {
            const response: usersRequest = await AxiosInstance.get(url)
            return response
        } catch (error: any) {
            return error.message
        }
    }
)

const initialState: leaderBoardState = {
    rank: [],
    status: 'idle',
    error: '',
    searchResults: {
        data: [],
    },
    data: [],
}

export const leaderBoardSlice = createSlice({
    name: 'leaderBoard',
    initialState,
    reducers: {
        CLEAR_SEARCH: (state) => {
            state.searchResults.data = []
        },
        CLEAR_DATA: (state) => {
            state.data = []
        },
    },
    extraReducers(buidler) {
        buidler

            .addCase(fetchMyProfile.pending, (state, action) => {
                state.status = 'pending'
            })
            .addCase(fetchMyProfile.fulfilled, (state, action) => {
                state.status = 'success'
                state.user = action.payload
            })
            .addCase(fetchMyProfile.rejected, (state, action) => {
                state.status = 'rejected'
                state.error = action.error.message
            })

            // .addCase(fetchLeaderBoard.pending, (state, action) => {
            //     state.status = 'success'
            //     state.data = []
            // })

            .addCase(fetchLeaderBoard.pending, (state, action) => {
                state.status = 'pending'
                state.data = []
            })
            .addCase(fetchLeaderBoard.fulfilled, (state, action) => {
                state.status = 'success'
                state.data = action?.payload?.data
            })
            .addCase(fetchLeaderBoard.rejected, (state, action) => {
                state.status = 'rejected'
                state.error = action.error.message
            })

            .addCase(fetchMyRankingLeaderBoard.fulfilled, (state, action) => {
                state.status = 'success'
                state.data = action.payload
            })
            .addCase(fetchMyRankingLeaderBoard.rejected, (state, action) => {
                state.status = 'rejected'
                state.error = action.error.message
            })
            .addCase(fetchMyRankingLeaderBoard.pending, (state, action) => {
                state.data = []
                state.status = 'pending'
            })
            .addCase(searchUserTag.pending, (state, action) => {
                state.status = 'pending'
                state.searchResults.data = []
            })

            .addCase(searchUserTag.fulfilled, (state, action) => {
                state.status = 'success'

                const searchedData =
                    action.payload === undefined ? [] : [action.payload]
                state.searchResults.data = searchedData[0].data
            })

            .addCase(fetchHallOfFame.pending, (state, action) => {
                state.status = 'pending'
            })
            .addCase(fetchHallOfFame.fulfilled, (state, action) => {
                state.status = 'success'
                state.hallOfFame = action.payload.data
            })
            .addCase(fetchHallOfFame.rejected, (state, action) => {
                state.status = 'rejected'
                state.error = action.error.message
            })
    },
})

export default leaderBoardSlice.reducer
export const { CLEAR_SEARCH, CLEAR_DATA } = leaderBoardSlice.actions
